import { createStore } from 'vuex';
import { professorApi } from '@/api/professor';
import { postApi } from '@/api/post';
import { authApi } from '@/api/auth';

export default createStore({
    state: {
        token: localStorage.getItem('token') || null,
        user: JSON.parse(localStorage.getItem('user')) || null,
        selectedSchool: null,
        selectedDepartment: null,
        professors: [],
        currentProfessor: null,
        posts: [],
        currentPost: null
    },
    
    mutations: {
        SET_PROFESSORS(state, professors) {
            state.professors = professors;
        },
        SET_CURRENT_PROFESSOR(state, professor) {
            state.currentProfessor = professor;
        },
        SET_USER(state, user) {
            state.user = user;
            if (user) {
                localStorage.setItem('user', JSON.stringify(user));
            } else {
                localStorage.removeItem('user');
            }
        },
        setSelectedSchool(state, school) {
            state.selectedSchool = school;
        },
        setSelectedDepartment(state, department) {
            state.selectedDepartment = department;
        },
        setProfessors(state, professors) {
            state.professors = professors;
        },
        setToken(state, token) {
            state.token = token;
            if (token) {
                localStorage.setItem('token', token);
            } else {
                localStorage.removeItem('token');
            }
        },
        SET_POSTS(state, posts) {
            state.posts = posts;
        },
        SET_CURRENT_POST(state, post) {
            state.currentPost = post;
        },
        UPDATE_POST(state, updatedPost) {
            const index = state.posts.findIndex(p => p._id === updatedPost._id);
            if (index !== -1) {
                state.posts.splice(index, 1, updatedPost);
            }
        }
    },
    
    actions: {
        // 教授相关
        async fetchProfessors({ commit }, params) {
            try {
                const professors = await professorApi.getProfessors(params);
                commit('SET_PROFESSORS', professors);
                return professors;
            } catch (error) {
                console.error('获取教授列表失败:', error);
                throw error;
            }
        },
        
        async fetchProfessor({ commit }, id) {
            try {
                const professor = await professorApi.getProfessor(id);
                commit('SET_CURRENT_PROFESSOR', professor);
                return professor;
            } catch (error) {
                console.error('获取教授详情失败:', error);
                throw error;
            }
        },
        
        async logout({ commit }) {
            commit('setToken', null);
            commit('SET_USER', null);
        },
        
        async fetchCurrentUser({ commit }) {
            try {
                const user = await authApi.getCurrentUser();
                commit('SET_USER', user);
                return user;
            } catch (error) {
                console.error('获取当前用户信息失败:', error);
                throw error;
            }
        },
        
        // Post 相关
        async fetchPosts({ commit }, params) {
            try {
                const posts = await postApi.getPosts(params);
                commit('SET_POSTS', posts);
                return posts;
            } catch (error) {
                console.error('获取帖子列表失败:', error);
                throw error;
            }
        },
        
        async createPost({ dispatch }, data) {
            try {
                const post = await postApi.createPost(data);
                await dispatch('fetchPosts', { professorId: data.professorId });
                return post;
            } catch (error) {
                console.error('创建帖子失败:', error);
                throw error;
            }
        },
        
        async likePost({ commit }, postId) {
            try {
                const updatedPost = await postApi.toggleLike(postId);
                commit('UPDATE_POST', updatedPost);
                return updatedPost;
            } catch (error) {
                console.error('点赞失败:', error);
                throw error;
            }
        },
        
        async fetchComments(_, postId) {
            try {
                return await postApi.getComments(postId);
            } catch (error) {
                console.error('获取评论失败:', error);
                throw error;
            }
        },
        
        async createComment(_, { postId, data }) {
            try {
                return await postApi.createComment(postId, data);
            } catch (error) {
                console.error('创建评论失败:', error);
                throw error;
            }
        },
        
        async likeComment(_, { postId, commentId }) {
            try {
                return await postApi.toggleCommentLike(postId, commentId);
            } catch (error) {
                console.error('点赞评论失败:', error);
                throw error;
            }
        }
    },
    
    getters: {
        getProfessorById: (state) => (id) => {
            return state.professors.find(p => p._id === id);
        },
        isAuthenticated: state => !!state.token && !!state.user,
        getPostsByProfessorId: (state) => (professorId) => {
            return state.posts.filter(p => p.professorId === professorId);
        },
        currentUser: state => state.user
    }
}); 